import { render, staticRenderFns } from "./selectCustomer.vue?vue&type=template&id=70151cda&scoped=true"
import script from "./selectCustomer.vue?vue&type=script&lang=js"
export * from "./selectCustomer.vue?vue&type=script&lang=js"
import style0 from "./selectCustomer.vue?vue&type=style&index=0&id=70151cda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70151cda",
  null
  
)

export default component.exports